<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>Petrol Bill</strong> 

          </div>


          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
             
             

              <li class="nav-item">
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Pending</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">Approved</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 3"  class="nav-link" :class="{'active' : isActiveTab(3)}" >Rejected</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 4"  class="nav-link" :class="{'active' : isActiveTab(4)}" >Feedback</a>
              </li>
             
            </ul>
          </div>
           
          </b-col>
          <b-col md="12" >
       

            <div class="tab-panel" v-if="isActiveTab(1)">
            <petrolpending style="width:70%;"></petrolpending>
            </div>

            <div class="tab-panel" v-if="isActiveTab(2)">
              <petrolapprove style="width:70%;"></petrolapprove>
            </div>

            <div class="tab-panel" v-if="isActiveTab(3)">
            <petrolreject style="width:70%;" ></petrolreject>
            </div>
            <div class="tab-panel" v-if="isActiveTab(4)">
            <petrolfeedback style="width:70%;" ></petrolfeedback>
            </div>
     
        
             </b-col>

          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  </div>   


</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";




import petrolpending from './petrolpending.vue'
import petrolapprove from './petrolapprove.vue'

import petrolreject from './petrolreject.vue'
import petrolfeedback from './petrolfeedback.vue'

export default {
  data: function() {
    return {
      // activeTab: '',
      activeTab: 1,
      petrolpending,
      petrolapprove,
      petrolreject,
      petrolfeedback,
      name: 'PetrolBill'
     
    };
  },
  components: {
   

    petrolpending,
    petrolapprove,
    petrolreject,
    petrolfeedback

  },
 created: function() {
    this.isActiveTab(1);
  },
 
  methods: {
    isActiveTab(id)

    {
      
       return this.activeTab === id
    },



    

  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }




  

};
</script>
